"use client";

import type { FC, Ref } from "react";
import {
  HouseValueTrendContent,
  type HouseValueTrendContentProps,
} from "@huub-web/shared";
import { ValueParser } from "@huub-web/ui/components/ValueParser";

import type { HouseValueTrendRecord } from "../HouseValueTrendTemplate";
import type { TemplateCollection } from "../../types";
import { TemplatesParser } from "../../components/TemplatesParser/TemplatesParser";

export interface HouseValueTrendContentTemplateProps {
  description?: string;
  woz: {
    description?: string;
    records: HouseValueTrendRecord[];
    templates?: TemplateCollection;
  };
  price: {
    description?: string;
    records: HouseValueTrendRecord[];
    templates?: TemplateCollection;
  };
  tips?: HouseValueTrendContentProps["tips"];
  templates?: TemplateCollection;
}

/**
 * @deprecated
 */
export const HouseValueTrendContentTemplate: FC<
  HouseValueTrendContentTemplateProps & { ref?: Ref<HTMLDivElement> }
> = ({ description, woz, price, tips, templates, ref, ...props }) => {
  const wozRecords = woz.records?.map((record) => ({
    subtitle: record.title,
    title: <ValueParser value={{ type: "money", value: record.value }} />,
    percentage: record.percentage,
  }));

  const priceRecords = price.records?.map((record) => ({
    subtitle: record.title,
    title: <ValueParser value={{ type: "money", value: record.value }} />,
    percentage: record.percentage,
  }));

  return (
    <HouseValueTrendContent
      ref={ref}
      description={description}
      woz={{
        ...woz,
        records: wozRecords,
        children: woz.templates && (
          <TemplatesParser templates={woz.templates} level={1} />
        ),
      }}
      price={{
        ...price,
        records: priceRecords,
        children: price.templates && (
          <TemplatesParser templates={price.templates} level={1} />
        ),
      }}
      tips={tips}
      {...props}
    >
      {templates && <TemplatesParser templates={templates} level={1} />}
    </HouseValueTrendContent>
  );
};
